import style from './animatedArrow.module.css'

export default function AnimatedArrow({arrowStyle}) {
    return (
      <div style={arrowStyle} className={style.arrowContainer}>
      <div className={style.arrow}></div>
    </div>
    )
  }